<template>
  <Teleport to="body">
    <dialog
      id="mobile-menu"
      ref="panel"
      class="menu-sheet"
      aria-labelledby="menu-title"
      @cancel.prevent="close"
      @click="onBackdrop"
    >
      <div class="menu-content">
        <div class="menu-heading">
          <span id="menu-title" class="eyebrow">White Pearl Ink</span
          ><button class="icon-button" aria-label="Menü schliessen" @click="close">
            <InkIcon name="close" />
          </button>
        </div>
        <nav class="menu-links" aria-label="Alle Seiten">
          <router-link v-for="(item, i) in links" :key="item.to" :to="item.to" @click="close"
            ><span class="menu-number">0{{ i + 1 }}</span
            >{{ item.label }}<InkIcon name="diagonal"
          /></router-link>
        </nav>
        <router-link to="/anfrage" class="button button-primary" @click="close"
          >Deine Idee anfragen <InkIcon name="arrow"
        /></router-link>
        <div class="menu-foot">
          <p>Art & Soul by Rebecca.<br />Kreuzlingen, Schweiz.</p>
          <a
            class="icon-button"
            href="https://www.instagram.com/whitepearl.ink/"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="White Pearl Ink auf Instagram"
            ><InkIcon name="instagram"
          /></a>
        </div>
      </div>
    </dialog>
  </Teleport>
</template>
<script setup>
import { ref, watch, onBeforeUnmount } from 'vue';
import InkIcon from '@/components/ui/InkIcon.vue';
const props = defineProps({ open: Boolean });
const emit = defineEmits(['close']);
const panel = ref(null);
let overflow = '';
const links = [
  { to: '/', label: 'Entdecken' },
  { to: '/tattoos', label: 'Tattoos' },
  { to: '/art', label: 'Kunstwerke' },
  { to: '/about-me', label: 'Über mich' },
  { to: '/pets', label: 'Haustiere' },
  { to: '/studio', label: 'Das Studio' },
];
const close = () => emit('close');
const onBackdrop = (event) => {
  if (event.target === panel.value) close();
};
watch(
  () => props.open,
  (open) => {
    if (open) {
      overflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      panel.value.showModal();
    } else {
      panel.value?.close();
      document.body.style.overflow = overflow;
    }
  }
);
onBeforeUnmount(() => {
  if (props.open) document.body.style.overflow = overflow;
});
</script>
